import React from 'react';
import { WIZARD_STEP_ORDER, WIZARD_STEP_LABELS } from '../constants/workoutWizardSteps';

export default function WizardStepper({ currentStep, className = '' }) {
  const idx = WIZARD_STEP_ORDER.indexOf(currentStep);
  const formSteps = WIZARD_STEP_ORDER.filter((s) => s !== 'pipeline' && s !== 'review');

  return (
    <nav className={`flex flex-wrap gap-1.5 ${className}`} aria-label="Progresso do wizard">
      {formSteps.map((stepId, i) => {
        const stepIdx = WIZARD_STEP_ORDER.indexOf(stepId);
        const done = idx > stepIdx;
        const active = stepId === currentStep || (currentStep === 'pipeline' && stepId === 'limitations') || (currentStep === 'review' && stepId === 'limitations');
        const isReviewOrPipe = currentStep === 'pipeline' || currentStep === 'review';
        const showActive = active || (isReviewOrPipe && stepId === 'limitations' && currentStep === 'pipeline') || (currentStep === 'review' && i === formSteps.length - 1);

        return (
          <span
            key={stepId}
            className={`rounded-full border px-2.5 py-1 font-mono text-[9px] uppercase tracking-wide ${
              showActive
                ? 'border-iron-accent bg-iron-accent/15 text-iron-accent'
                : done
                  ? 'border-iron-border text-iron-muted-strong'
                  : 'border-iron-border/60 text-iron-muted'
            }`}
          >
            {i + 1}. {WIZARD_STEP_LABELS[stepId]}
          </span>
        );
      })}
      {(currentStep === 'pipeline' || currentStep === 'review') && (
        <span
          className={`rounded-full border px-2.5 py-1 font-mono text-[9px] uppercase tracking-wide ${
            currentStep === 'pipeline'
              ? 'border-iron-accent bg-iron-accent/15 text-iron-accent'
              : 'border-iron-border text-iron-muted-strong'
          }`}
        >
          {currentStep === 'pipeline' ? '…' : '✓'} {WIZARD_STEP_LABELS.pipeline}
        </span>
      )}
      {currentStep === 'review' && (
        <span className="rounded-full border border-iron-accent bg-iron-accent/15 px-2.5 py-1 font-mono text-[9px] uppercase tracking-wide text-iron-accent">
          {WIZARD_STEP_LABELS.review}
        </span>
      )}
    </nav>
  );
}
